export const blockIconsTransportationTramNew = (
	<span className='material-symbols-outlined'>tram</span>
);
